
import React,{ useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Home = () => {
    React.useEffect(() => {
    const btn = document.getElementById("menu-toggle");
    const wrapper = document.getElementById("wrapper");

    const toggleMenu = () => wrapper.classList.toggle("toggled");
    
    btn.addEventListener("click", toggleMenu);

    // Bersihkan event listener saat komponen unmount
    return () => btn.removeEventListener("click", toggleMenu);
  }, []);

  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/login');
  };
  const location = useLocation();
 const { user, loading, logout } = useAuth();
  const [menu, setMenu] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const menuConfig = {
    admin: [
        { label: "Dashboard", path: "/dashboard" },
        { label: "Users", path: "/users" },
        { label: "Settings", path: "/settings" }
    ],
    user: [
        { label: "Dashboard", path: "/dashboard" },
        { label: "Profile", path: "/profile" }
    ],
    Pendidik: [
        { label: "Dashboard", path: "/pendidik", icon: "ti ti-layout-grid" },
        { label: "Pembelajaran", path: "/pendidik/pembelajaran", icon: "ti ti-layout-list" },
        {
            label: "Evaluasi", path: "#", icon: "ti ti-devices", submenu: [
                { label: "Ujian Saya", path: "/pendidik/mstujianpendidik", icon: "ti ti-layout-list" },
                { label: "Pelaksanaan", path: "/pendidik/ujian", icon: "ti ti-calendar-event" },
            ]
        },
        //   { label: "Absensi", path: "/admin/absensi", icon:"ti ti-barcode" },
        //   { label: "Informasi", path: "/admin/absensi", icon:"ti ti-barcode" }
    ],
    ppdb: [
        { label: "Peserta Baru", path: "/admin/ppdb/peserta", icon: "ti ti-layout-list" },
        { label: "Verifikasi", path: "/admin/ppdb/verifikasi", icon: "ti ti-devices" },
        { label: "Pesan", path: "/admin/ppdb/pesan", icon: "ti ti-barcode" }
    ],
    Operator: [
        {
            label: "Sebagai Guru", path: "#", icon: "ti ti ti-devices", submenu: [
                { label: "Pembelajaran", path: "/pendidik/pembelajaran", icon: "ti ti-layout-list" },
                { label: "Evaluasi", path: "/pendidik/mstujianpendidik", icon: "ti ti-devices" },
            ]
        },

        {
            label: "Refrensi", path: "#", icon: "ti ti-arrows-split", submenu: [
                { label: "Kelas", path: "/admin/refrensi/kelas", icon: "ti ti-layout-list" },
                { label: "Mata Pelajaran", path: "/admin/refrensi/mapel", icon: "ti ti-book" },
                { label: "Pembelajaran", path: "/admin/refrensi/pembelajaran", icon: "ti ti-layout-list" },
                { label: "Pendidik", path: "/admin/refrensi/pendidik", icon: "ti ti-user-check" },
                { label: "Peserta didik", path: "/admin/refrensi/pd", icon: "ti ti-users" },
                { label: "Absensi", path: "/admin/comingsoon", icon: "ti ti-users" },
                // { label: "Jadwal", path: "/admin/refrensi/setupjadwal", icon: "ti ti-users" },
            ]
        },
         {
            label: "Pengguna", path: "/admin/pengguna/daftarpengguna", icon: "ti ti-users"
        },
        {
            label: "Ujian", path: "#", icon: "ti ti ti-devices", submenu: [
                { label: "Daftar Ujian", path: "/admin/refrensi/msttes", icon: "ti ti-layout-list" },
                { label: "Jadwal Ujian", path: "/admin/refrensi/jadwalujian", icon: "ti ti-calendar-event" },
                { label: "Kartu Ujian", path: "/admin/refrensi/kartuujian", icon: "ti ti-calendar-event" },
            ]
        },
        {
            label: "Absensi", path: "/admin/absensi/jenisabsensi", icon: "ti ti-qrcode", 
            // submenu: [
            //     // { label: "Master Absensi", path: "/admin/absensi/jenisabsensi", icon: "ti ti-layout-list" },
            //     // { label: "Jadwal Absensi", path: "/admin/absensi/jadwalabsensi", icon: "ti ti-devices" },
            //     // { label: "Rekap Absensi", path: "/pendidik/subtes", icon: "ti ti-devices" },
            // ]
        },
        // { label: "Backup dan Sycron Data", path: "/admin/refrensi/sycron", icon:"ti ti-arrows-sort" },
        { label: "Jadwal Pembelajaran", path: "#", icon: "ti ti-replace",
             submenu: [
                { label: "Setup Jadwal", path: "/admin/refrensi/setupjadwal", icon: "ti ti-layout-list" },
                { label: "Kalender Jadwal", path: "/admin/refrensi/jadwalpembelajaran", icon: "ti ti-devices" },
              
            ]
         },
        { label: "Jurnal Pembelajaran", path: "/admin/jurnal/jurnalrombel", icon: "ti ti-friends" },
        { label: "Bendahara", path: "#", icon: "ti ti-businessplan",
              submenu: [
                { label: "Jenis Pembayaran", path: "/admin/bendahara/getjenispembayaran", icon: "ti ti-layout-list" },
                { label: "Pembayaran Langsung", path: "/admin/refrensi/jadwalpembelajaran", icon: "ti ti-devices" },
                { label: "Tagihan", path: "/admin/bendahara/tagihanpembayaran", icon: "ti ti-devices" },
                { label: "Rakaputulasi Pembayaran", path: "/admin/refrensi/jadwalpembelajaran", icon: "ti ti-devices" },
            ]
         },
        { label: "sarana Prasarana", path: "/admin/jurnal/jurnalrombel", icon: "ti ti-ruler" },
        { label: "SPMB/PPDB", path: "/admin/jurnal/jurnalrombel", icon: "ti ti-user-check" },
        { label: "Pengumuman", path: "/admin/refrensi/pengumuman", icon: "ti ti-message-report" },
        { label: "Pengaturan", path: "/admin/refrensi/pengaturan", icon: "ti ti-settings" },


    ]
};

 const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);
  useEffect(() => {
    const fetchMenu = async () => {
      console.log(user?.role)
      window.initScripts?.();
     setMenu(menuConfig[user?.akses || "Operator"]);
    };

    fetchMenu();
    
  }, [navigate]);
const toggleDropdown = (index) =>
    setOpenDropdown(openDropdown === index ? null : index);
  return (
     <div className={`wrapper ${showSidebar ? "sidebar-open" : ""}` } id="wrapper">
  {/* SIDEBAR */}
  <div className="border-end text-dark" id="sidebar-wrapper">
    <div className="sidebar-heading border-bottom logodash ">
      <img src="/assets/images/logogvfix d (2).png" alt="logo" width={100} />
      <span className='titlesekolah'>{user?.nama_sekolah || "-"}</span>
    </div>
    <div className="sidebar-heading border-bottom mt-auto py-3 px-2">
      <div className="row m-0">
        <div className="col-3">
        <img
          src={user?.photo || `/assets/images/userd.png`}
          width={45}
          className="rounded-circle me-2"
          alt="User"
        />
        </div>
        <div className="col-8">
        
          <div className="fw-bold small text-capitalize">{user?.nama}</div>
          <div className="text-muted small">{user?.wa_number}</div>
       
       <a
       href="#"
  className="d-flex align-items-center text-decoration-none text-danger"
  onClick={handleLogout}
  title="Logout"
>
  <i className="ti ti-logout fs-5 me-2"></i>
  Logout
</a>
        </div>
      </div>
    </div>

    {/* MENU UTAMA */}
    <div className="list-group list-group-flush flex-grow-1 overflow-auto">
      {menu.map((item, index) =>
        item.submenu ? (
          <div key={index} className="dropdown-sidebar">
            <a
              href="#"
              onClick={() => toggleDropdown(index)}
              className={`list-group-item2 d-flex justify-content-between align-items-center ${
                openDropdown === index ? "active-item" : ""
              }`}
            >
              <span>
                <i className={`ti ${item.icon} me-2`}></i>
                {item.label}
              </span>
              <i
                className={`ti ${
                  openDropdown === index ? "ti-chevron-up" : "ti-chevron-down"
                }`}
              ></i>
            </a>

            {openDropdown === index && (
              <div className="submenu">
                {item.submenu.map((sub, subIndex) => (
                  <a
                    key={subIndex}
                    href={sub.path}
                    style={{border: "none"}}
                    className="list-group-item bg-secondary"
                  >
                    <i className={`ti ${sub.icon} me-2`}></i>
                    {sub.label}
                  </a>
                ))}
              </div>
            )}
          </div>
        ) : (
          <a
            key={index}
            href={item.path}
            className="list-group-item2 "
          >
            <i className={`ti ${item.icon} me-2`}></i>
            {item.label}
          </a>
        )
      )}
    </div>
  </div>

  {/* KONTEN */}
  <div id="page-content-wrapper" className="flex-grow-1 position-relative">
    {/* Overlay saat sidebar terbuka di mobile */}
    {showSidebar && (
      <div className="overlay" onClick={() => setShowSidebar(false)}></div>
    )}

    <div className="container-fluid p-3">
      <Outlet />
    </div>

    {/* NAVBAR BAWAH (HANYA MOBILE) */}
    <div className="mobile-bottom-nav d-md-none">
      <button className="nav-btn" onClick={() => (window.location.href = "/")}>
        <i className="ti ti-home"></i>
        <span>Home</span>
      </button>
      <button
        className="nav-btn"
        id="menu-toggle"
        onClick={() => setShowSidebar(!showSidebar)}
      >
        <i className="ti ti-menu-2"></i>
        <span>Menu</span>
      </button>
    </div>
  </div>
</div>

  );
};
 
export default Home;